import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Divider,
  TextField,
  useTheme,
  Grid,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  MenuItem,
  Box,
  Modal,
} from "@mui/material";
import Icons from "../../Utils/Icons";
import { GET, POST, DELETE } from "../Generic/CrudRequest";
import ModalGeneric from "../Generic/ModalGeneric";
import Alerts from "../../Utils/Alerts";
import { useTranslation } from "react-i18next";


export default function DetailsUnit({ props, inspectionData, config }) {
  const theme = useTheme();
  const { t } = useTranslation();
  const [inspection, setInspection] = useState(inspectionData);
  const [addDaño, setAddDaño] = useState(false);
  const [areas, setAreas] = useState([]);
  const [area, setArea] = useState(0);
  const [daños, setDaños] = useState([]);
  const [daño, setDaño] = useState(0);
  const [severidades, setSeveridades] = useState([]);
  const [severidad, setSeveridad] = useState(0);
  const [cantidad, setCantidad] = useState(0);
  const [descripcion, setDescripcion] = useState("");
  const [inspeccionGeneralDano, setInspeccionGeneralDano] = useState(0);
  const [isEditOrAdd, setIsEditOrAdd] = useState(false);
  const [errors, setErrors] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalDescription, setModalDescription] = useState("");
  const [bodyModal, setBodyModal] = useState(null);
  const [dañoId, setDañoId] = useState(0);
  const [selectedImage, setSelectedImage] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [caseModal, setCaseModal] = useState(0);
  const [imageSend, setImageSend] = useState("");
  const [fileName, setFileName] = useState("");
  const [imageURL, setImageURL] = useState("");
  const [imageArray, setImageArray] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const language = localStorage.getItem("language");

  useEffect(() => {
    fetchArea();
    fetchDamage();
    fetchSeverity();
  }, [inspectionData, language]);

  const columns = [
    { id: "area", label: t("inspections.details.unit.damageReview.area"), minWidth: "100px" },
    { id: "dano", label: t("inspections.details.unit.damageReview.damage"), minWidth: "100px" },
    { id: "severidad", label: t("inspections.details.unit.damageReview.severity"), minWidth: "100px" },
    { id: "cantidad", label: t("inspections.details.unit.damageReview.quantity"), minWidth: "100px" },
    { id: "descripcion", label: t("inspections.details.unit.damageReview.description"), minWidth: "100px" },
  ];

  useEffect(() => {
    if (imageSend !== "" && fileName !== "") {
      setIsModalOpen(true);
      setCaseModal(3);
      setModalTitle(t("inspections.details.modalTitleAddImage"));
      setModalDescription("");
      setBodyModal(
        <Grid item xs={12} marginTop={2}>
          <div
            //onDrop={handleFileDrop}
            //onDragOver={handleDragOver}
            style={{
              textAlign: "center",
              padding: "3px",
              border: "2px dashed #aaa",
              borderRadius: "4px",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: theme.palette.primary.main,
              },
            }}
          >
            <input
              type="file"
              id="file_Documento"
              accept="image/*"
              onChange={handleFileUpload}
              style={{ display: "none" }}
              //ref={fileInputRef}
            />
            {imageSend !== "" ? (
              <>
                <img
                  src={imageURL}
                  alt={t("inspections.details.messages.loadedImage")}
                  style={{
                    width: "50%",
                    height: "50%",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setSelectedImage(imageURL);
                    setOpenModal(true);
                  }}
                />
                <Typography>{fileName}</Typography>
              </>
            ) : (
              <label htmlFor="file_Documento">
                <div>
                  <Icons
                    fontSize="large"
                    iconName="Image"
                    style={{
                      marginBottom: "1px",
                      color: theme.palette.primary.main,
                    }}
                  />
                  <Typography>{t("inspections.details.clickToUpload")}</Typography>
                </div>
              </label>
            )}
          </div>
        </Grid>
      );
    }
  }, [imageSend, fileName]);

  useEffect(() => {
    if (!isModalOpen) {
      setImageSend("");
      setFileName("");
      setCaseModal(0);
    }
  }, [isModalOpen]);

  const fetchArea = async () => {
    const areasData = await GET(`${config.url}/api/Area`);
    setAreas(areasData);
  };

  const fetchDamage = async () => {
    const damageData = await GET(`${config.url}/api/Damage`);
    setDaños(damageData);
  };

  const fetchSeverity = async () => {
    const severityData = await GET(`${config.url}/api/Severity`);
    setSeveridades(severityData);
  };

  const handleAddDaño = () => {
    setAddDaño(true);
    setIsEditOrAdd(true);
    fetchArea();
    fetchDamage();
    fetchSeverity();
  };

  const handleEditDaño = (data) => {
    setAddDaño(true);
    setIsEditOrAdd(false);
    setArea(data.idArea);
    setDaño(data.idDano);
    setSeveridad(data.idSeveridad);
    setCantidad(data.cantidad);
    setDescripcion(data.descripcion);
    setInspeccionGeneralDano(data.idInspectionGeneralDano);
    fetchArea();
    fetchDamage();
    fetchSeverity();
  };

  const handleCancelAddDaño = () => {
    setAddDaño(false);
    setArea(0);
    setDaño(0);
    setSeveridad(0);
    setCantidad(0);
    setDescripcion("");
  };

  const handleSubmitAddDamage = () => {
    if (isEditOrAdd === true) addDamage();
    else if (isEditOrAdd === false) editDamage();
  };

  const addDamage = async () => {
    const newErrors = {};

    if (area === 0) newErrors.area = t("inspections.details.unit.damageReview.validation.areaRequired");

    if (daño === 0) newErrors.daño = t("inspections.details.unit.damageReview.validation.damageRequired");

    if (severidad === 0) newErrors.severidad = t("inspections.details.unit.damageReview.validation.severityRequired");

    if (cantidad === 0) newErrors.cantidad = t("inspections.details.unit.damageReview.validation.quantityRequired");

    if (descripcion === "") newErrors.descripcion = t("inspections.details.unit.damageReview.validation.descriptionRequired");

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const idInspection =
      inspection?.inspectionGeneral?.danoInspectionGeneral.length !== 0
        ? inspection.inspectionGeneral.danoInspectionGeneral[0].idInspection
        : 0;

    const newInspeccionDTO = {
      idInspeccionGeneral:
        inspection?.inspectionGeneral.idInspeccionGeneral || 0,
      idUnidad: inspection.inspeccionUnidad.idUnidad || 0,
      idInspeccion: idInspection,
      inpeccionGeneralDano: {
        idInspectionGeneralDano: inspeccionGeneralDano,
        idInspection: idInspection,
        idArea: area,
        area: "",
        idDano: daño,
        dano: "",
        idSeveridad: severidad,
        severidad: "",
        cantidad: cantidad,
        foto: [],
        danoImagen: [
          {
            idInspeccionGeneralDanoImagen: 0,
            idInspeccionGeneralDano: inspeccionGeneralDano,
            nombreArchivo: "",
            base64: imageArray,
            estatus: true,
          },
        ],
        descripcion: descripcion,
      },
    };

    if (imageArray === "") {
      handleShowAlert(t("inspections.details.unit.damageReview.validation.imagesRequired"), "warning");
      return;
    }

    await POST(
      `${config.url}/api/Inspections/AddEditInspectionDano`,
      newInspeccionDTO
    );
    window.location.reload();
  };

  const editDamage = async (row) => {
    const newErrors = {};

    if (area === 0) newErrors.area = t("inspections.details.unit.damageReview.validation.areaRequired");

    if (daño === 0) newErrors.daño = t("inspections.details.unit.damageReview.validation.damageRequired");

    if (severidad === 0) newErrors.severidad = t("inspections.details.unit.damageReview.validation.severityRequired");

    if (cantidad === 0) newErrors.cantidad = t("inspections.details.unit.damageReview.validation.quantityRequired");

    if (descripcion === "") newErrors.descripcion = t("inspections.details.unit.damageReview.validation.descriptionRequired");

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const idInspection =
      inspection?.inspectionGeneral?.danoInspectionGeneral.length !== 0
        ? inspection.inspectionGeneral.danoInspectionGeneral[0].idInspection
        : 0;

    const newInspeccionDTO = {
      idInspeccionGeneral:
        inspection?.inspectionGeneral.idInspeccionGeneral || 0,
      idUnidad: inspection.inspeccionUnidad.idUnidad || 0,
      idInspeccion: idInspection,
      inpeccionGeneralDano: {
        idInspectionGeneralDano: inspeccionGeneralDano,
        idInspection: idInspection,
        idArea: area,
        area: "",
        idDano: daño,
        dano: "",
        idSeveridad: severidad,
        severidad: "",
        cantidad: cantidad,
        foto: [],
        danoImagen: [
          {
            idInspeccionGeneralDanoImagen: 0,
            idInspeccionGeneralDano: inspeccionGeneralDano,
            nombreArchivo: "",
            base64: imageArray,
            estatus: true,
          },
        ],
        descripcion: descripcion,
      },
    };

    await POST(
      `${config.url}/api/Inspections/AddEditInspectionDano`,
      newInspeccionDTO
    );
    window.location.reload();
  };

  const deleteDamage = async () => {
    await DELETE(`${config.url}/api/GeneralInspectionDamages/${dañoId}`);
    window.location.reload();
  };

  const handleDeleteDamage = (id) => {
    setIsModalOpen(true);
    setCaseModal(1);
    setModalTitle(t("inspections.details.unit.damageReview.deleteConfirm.title"));
    setModalDescription(t("inspections.details.unit.damageReview.deleteConfirm.message"));
    setBodyModal(<></>);
    setDañoId(id);
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    handleFile(file);
  };

  const handleFile = (file) => {
    const reader = new FileReader();

    if (!file.type.startsWith("image/")) {
      handleShowAlert(t("inspections.details.messages.onlyImagesAllowed"), "warning");
      return;
    }

    reader.onload = async (event) => {
      const binaryString = event.target.result;
      const base64String = reader.result.split(",")[1];
      setImageSend(base64String);
      setImageURL(binaryString);
      setFileName(file.name);
    };

    reader.readAsDataURL(file);
  };

  const handleAddImageDamage = () => {
    setIsModalOpen(true);
    setCaseModal(2);
    setImageArray("");
    setModalTitle(t("inspections.details.modalTitleAddImage"));
    setModalDescription("");
    setBodyModal(
      <Grid item xs={12} marginTop={2}>
        <div
          //onDrop={handleFileDrop}
          //onDragOver={handleDragOver}
          style={{
            textAlign: "center",
            padding: "3px",
            border: "2px dashed #aaa",
            borderRadius: "4px",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: theme.palette.primary.main,
            },
          }}
        >
          <input
            type="file"
            id="file_Documento"
            accept="image/*"
            onChange={handleFileUpload}
            style={{ display: "none" }}
            //ref={fileInputRef}
          />
          {imageSend !== "" ? (
            <img
              src={imageURL}
              alt={t("inspections.details.messages.loadedImage")}
              style={{
                width: "50%",
                height: "50%",
                cursor: "pointer",
              }}
              onClick={() => {
                setSelectedImage(imageURL);
                setOpenModal(true);
              }}
            />
          ) : (
            <label htmlFor="file_Documento">
              <div>
                <Icons
                  fontSize="large"
                  iconName="Image"
                  style={{
                    marginBottom: "1px",
                    color: theme.palette.primary.main,
                  }}
                />
                <Typography>{t("inspections.details.clickToUpload")}</Typography>
              </div>
            </label>
          )}
        </div>
      </Grid>
    );
  };

  const handleOpenModalImagesDamage = (idInspectionGeneralDano) => {
    setIsModalOpen(true);
    setCaseModal(2);
    setModalTitle(t("inspections.details.gallery.title"));
    setModalDescription("");
    setBodyModal(
      <Grid container spacing={2} marginTop={1}>
        {inspection.inspectionGeneral.danoInspectionGeneral
          .filter(
            (filter) =>
              filter.idInspectionGeneralDano === idInspectionGeneralDano
          )
          .map((value, index) => (
            <React.Fragment key={index}>
              {value.foto.length > 0 ? (
                value.foto.map((valueDamage, indexDamage) => (
                  <Grid item xs={2} key={indexDamage}>
                    <img
                      src={`${config.url}/${config.paths.damageReview}/${valueDamage}`}
                      alt={t("inspections.details.messages.noImage", { index: indexDamage + 1 })}
                      style={{
                        width: "100%",
                        height: "100%",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setSelectedImage(
                          `${config.url}/${config.paths.damageReview}/${valueDamage}`
                        );
                        setOpenModal(true);
                      }}
                    />
                  </Grid>
                ))
              ) : (
                <Grid item xs={12} key={index} style={{ textAlign: "center" }}>
                  <Icons iconName="ImageNotSupported" fontSize="large" />
                  <Typography>
                    {t("inspections.details.gallery.noImagesFound")}
                  </Typography>
                </Grid>
              )}
            </React.Fragment>
          ))}
        {inspection.inspectionGeneral.danoInspectionGeneral.length === 0 && (
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <Icons iconName="ImageNotSupported" fontSize="large" />
            <Typography>{t("inspections.details.gallery.noImagesFound")}</Typography>
          </Grid>
        )}
      </Grid>
    );
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setCaseModal(0);
  };

  const handleAcceptModal = () => {
    if (caseModal === 1) deleteDamage();
    else if (caseModal === 2) setIsModalOpen(false);
    else if (caseModal === 3) {
      setImageArray(imageSend);
      setIsModalOpen(false);
    }
  };

  const handleShowAlert = (message, type) => {
    setAlertMessage(message);
    setAlertType(type);
    setShowAlert(true);
  };

  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  return (
    <>
      {showAlert && (
        <Alerts
          error={alertMessage}
          type={alertType}
          onClose={handleCloseAlert}
        />
      )}
      <Card
        variant="outlined"
        sx={{
          overflow: "hidden",
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
          border: "1px solid rgba(0, 0, 0, 0.1)",
          borderRadius: 2,
          maxWidth: "calc(100% - 32px)",
          margin: "auto",
          marginTop: 2,
        }}
      >
        {
          <Modal
            open={openModal}
            onClose={() => setOpenModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <img
                src={selectedImage}
                alt={t("inspections.details.messages.selectedImage")}
                style={{ maxWidth: "100%", maxHeight: "100vh" }}
              />
            </Box>
          </Modal>
        }
        {isModalOpen && (
          <ModalGeneric
            open={isModalOpen}
            title={modalTitle}
            description={modalDescription}
            onClose={handleCloseModal}
            onAccept={handleAcceptModal}
            bodyComponent={bodyModal}
          />
        )}
        <CardContent sx={{ maxWidth: "calc(100% - 64px)", margin: "auto" }}>
          <Typography
            variant="h5"
            sx={{
              flex: "1",
              color: theme.palette.primary.main,
            }}
          >
            {t("inspections.details.unit.title")}
          </Typography>
          <Divider sx={{ maxWidth: "100%", marginTop: 2 }} />
          <Grid container spacing={2} sx={{ marginTop: 2 }}>
            <Grid item xs={12} md={3}>
              <TextField
                label={t("inspections.details.unit.vin")}
                name="vin"
                variant="standard"
                fullWidth
                value={inspection?.inspeccionUnidad.vin}
                InputProps={{ disableUnderline: true }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                label={t("inspections.details.unit.model")}
                name="modelo"
                variant="standard"
                fullWidth
                value={inspection?.inspeccionUnidad.modelo}
                InputProps={{ disableUnderline: true }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                label={t("inspections.details.unit.brand")}
                name="marca"
                variant="standard"
                fullWidth
                value={inspection?.inspeccionUnidad.marca}
                InputProps={{ disableUnderline: true }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                label={t("inspections.details.unit.load")}
                name="carga"
                variant="standard"
                fullWidth
                value={inspection?.inspeccionUnidad.carga || t("pagination.notAvailable")}
                InputProps={{ disableUnderline: true }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Card
        variant="outlined"
        sx={{
          overflow: "hidden",
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
          border: "1px solid rgba(0, 0, 0, 0.1)",
          borderRadius: 2,
          maxWidth: "calc(100% - 32px)",
          margin: "auto",
          marginTop: 2,
        }}
      >
        <CardContent sx={{ maxWidth: "calc(100% - 64px)", margin: "auto" }}>
          <CardContent
            sx={{
              display: "flex",
              alignItems: "center",
              margin: -2,
              flexWrap: "wrap",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                flex: "1",
                color: theme.palette.primary.main,
              }}
            >
              {t("inspections.details.unit.damageReview.title")}
            </Typography>
            <Icons
              iconName="Add"
              fontSize="large"
              style={{
                marginLeft: "auto",
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.white.main,
              }}
              onClick={handleAddDaño}
              tooltip={t("buttons.add")}
            />
          </CardContent>
          <Divider sx={{ maxWidth: "100%", marginTop: 2 }} />
          <Paper
            sx={{
              maxWidth: "100%",
              margin: "auto",
              overflow: "hidden",
              boxShadow: "none",
              border: "none",
            }}
          >
            <TableContainer>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align="left"
                        style={{
                          minWidth: column.minWidth,
                          fontWeight: "bold",
                        }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                    <TableCell />
                    <TableCell />
                    <TableCell />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {inspection?.inspectionGeneral?.danoInspectionGeneral
                    .length === 0 && (
                    <TableRow>
                      <TableCell colSpan={columns.length + 1} align="center">
                        {t("inspections.details.unit.damageReview.noDamages")}
                      </TableCell>
                    </TableRow>
                  )}
                  {inspection?.inspectionGeneral?.danoInspectionGeneral.map(
                    (row, index) => {
                      return (
                        <TableRow key={index}>
                          {columns.map((column) => (
                            <TableCell key={column.id} align="left">
                              {row[column.id] !== null &&
                              row[column.id] !== "" ? (
                                row[column.id]
                              ) : (
                                <i>{t("pagination.notAvailable")}</i>
                              )}
                            </TableCell>
                          ))}
                          <TableCell>
                            <Icons
                              iconName="Collections"
                              fontSize="medium"
                              style={{
                                backgroundColor: theme.palette.primary.main,
                                color: "#fff",
                              }}
                              onClick={() =>
                                handleOpenModalImagesDamage(
                                  row.idInspectionGeneralDano
                                )
                              }
                              tooltip={t("inspections.details.gallery.gallery")}
                            />
                          </TableCell>
                          <TableCell>
                            <Icons
                              iconName="Edit"
                              fontSize="medium"
                              style={{
                                backgroundColor: theme.palette.primary.main,
                                color: "#fff",
                              }}
                              onClick={() => handleEditDaño(row)}
                              tooltip={t("buttons.edit")}
                            />
                          </TableCell>
                          <TableCell>
                            <Icons
                              iconName="Delete"
                              fontSize="medium"
                              style={{
                                backgroundColor: theme.palette.error.main,
                                color: "#fff",
                              }}
                              onClick={() =>
                                handleDeleteDamage(row.idInspectionGeneralDano)
                              }
                              tooltip={t("buttons.delete")}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    }
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            {addDaño && (
              <>
                <Grid container spacing={2} sx={{ marginTop: 2 }}>
                  <Grid item xs={12} md={3}>
                    <TextField
                      select
                      label={t("inspections.details.unit.damageReview.area")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="standard"
                      size="small"
                      value={area}
                      onChange={(e) => setArea(e.target.value)}
                      fullWidth
                      error={!!errors.area}
                      helperText={errors.area}
                    >
                      <MenuItem key={0} value={0}>
                        {t("inspections.details.unit.damageReview.select")}
                      </MenuItem>
                      {areas.map((area) => (
                        <MenuItem key={area.idArea} value={area.idArea}>
                            {language === "es" ? area.nombreEspanol : area.nombreIngles}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      select
                      label={t("inspections.details.unit.damageReview.damage")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="standard"
                      size="small"
                      value={daño}
                      onChange={(e) => setDaño(e.target.value)}
                      fullWidth
                      error={!!errors.daño}
                      helperText={errors.daño}
                    >
                      <MenuItem key={0} value={0}>
                        {t("inspections.details.unit.damageReview.select")}
                      </MenuItem>
                      {daños.map((daño) => (
                        <MenuItem key={daño.idDano} value={daño.idDano}>
                           {(() => {
                            //  console.log("Language value for daño:", language);
                            //  console.log("Daño data:", daño);
                             return language === "es" ? daño.nombreEspanol : daño.nombreIngles;
                           })()}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      select
                      label={t("inspections.details.unit.damageReview.severity")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="standard"
                      size="small"
                      value={severidad}
                      onChange={(e) => setSeveridad(e.target.value)}
                      fullWidth
                      error={!!errors.severidad}
                      helperText={errors.severidad}
                    >
                      <MenuItem key={0} value={0}>
                        {t("inspections.details.unit.damageReview.select")}
                      </MenuItem>
                      {severidades.map((severidad) => (
                        <MenuItem
                          key={severidad.idSeveridad}
                          value={severidad.idSeveridad}
                        >
                          {language === "es" ? severidad.nombreEspanol : severidad.nombreIngles}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      label={t("inspections.details.unit.damageReview.quantity")}
                      name="cantidad"
                      variant="standard"
                      fullWidth
                      value={cantidad}
                      onChange={(e) => setCantidad(e.target.value)}
                      error={!!errors.cantidad}
                      helperText={errors.cantidad}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      label={t("inspections.details.unit.damageReview.description")}
                      name="descripcion"
                      variant="standard"
                      fullWidth
                      value={descripcion}
                      onChange={(e) => setDescripcion(e.target.value)}
                      error={!!errors.descripcion}
                      helperText={errors.descripcion}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Icons
                      iconName="AddPhotoAlternate"
                      fontSize="medium"
                      style={{
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.white.main,
                      }}
                      onClick={handleAddImageDamage}
                      tooltip={t("inspections.details.unit.damageReview.addImage")}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  justifyContent="flex-end"
                  sx={{
                    marginTop: 2,
                    marginLeft: "-16px",
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{ backgroundColor: theme.palette.danger.main }}
                    onClick={handleCancelAddDaño}
                  >
                    {t("buttons.cancel")}
                  </Button>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: theme.palette.primary.main,
                      marginLeft: 1,
                    }}
                    onClick={handleSubmitAddDamage}
                  >
                    {t("buttons.save")}
                  </Button>
                </Grid>
              </>
            )}
          </Paper>
        </CardContent>
      </Card>
    </>
  );
}
